import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { FormattedMessage } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";

import SaveChangesButton from "components/shared/SaveChangesButton";
import ImagesUpload from "components/shared/ImagesUpload";
import removeImg from "assets/svgs/close.svg";

const Index = () => {
  const dispatch = useDispatch();
  const {
    handleSubmit,
    reset,
    formState: { errors },
    register,
  } = useForm();

  const [images, setImages] = useState([]);
  const [features, setFeatures] = useState([]);

  const { loading, section } = useSelector((state) => state.section);

  // get single page by slug
  useEffect(() => {
    dispatch(
      getSection({
        page: "home",
        slug: "hero",
      })
    );
  }, [dispatch]);

  // reset form with fetched data
  useEffect(() => {
    if (section) {
      reset({
        ...section,
      });
      setFeatures(section.secFeatures || []);
      // Handle both string arrays and object arrays
      const normalized = Array.isArray(section.images)
        ? section.images.map((img) => {
            if (typeof img === "string") return { path: img };
            if (img?.path) return { ...img, path: img.path };
            if (img?.url) return { ...img, path: img.url };
            if (img?.src) return { ...img, path: img.src };
            // last resort: stringify to get something removable
            return { ...img, path: String(img?.path || img?.id || "") };
          })
        : [];

      setImages(normalized);
    }
  }, [section, reset]);

  const onSubmit = (data) => {
    if (images?.length > 0) {
      data.images = images?.map((image) => {
        return typeof image === "string" ? image : image.path;
      });
    }
    data.secFeatures = features;
    dispatch(
      editSection({ slug: "hero", page: "home", data: { section: data } })
    );
  };

  if (loading) return <Loader />;

  return (
    <div className="acc-form">
      <div className="card">
        <div className="card-head">
          <h4>
            <FormattedMessage id={"intro"} />
          </h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col xl={12} md={12}>
                <div className="hero-images">
                  <ImagesUpload
                    imagesURLs={images}
                    setImageURLs={setImages}
                    title="اضافة صور السلايدر"
                  />
                </div>
              </Col>

              <Col lg={6} xs={12}>
                <div className="form-group">
                  <h5>
                    <FormattedMessage id="subTitle" /> ({" "}
                    <FormattedMessage id="arabic-language" /> )
                  </h5>
                  <input
                    type="text"
                    className={`form-control ${
                      errors.subTitle ? "is-invalid" : ""
                    }`}
                    defaultValue={section?.secSubTitle?.ar || ""}
                    {...(errors.secSubTitle && { "aria-invalid": "true" })}
                    {...register("secSubTitle[ar]", { required: true })}
                  />
                  {errors.secSubTitle && (
                    <div className="invalid-feedback">
                      <FormattedMessage id={"thisFieldIsRequired"} />
                    </div>
                  )}
                </div>
              </Col>
              <Col lg={6} xs={12}>
                <div className="form-group">
                  <h5>
                    <FormattedMessage id="subTitle" /> ({" "}
                    <FormattedMessage id="english-language" /> )
                  </h5>
                  <input
                    type="text"
                    className={`form-control ${
                      errors.subTitle ? "is-invalid" : ""
                    }`}
                    defaultValue={section?.secSubTitle?.en || ""}
                    {...(errors.secSubTitle && { "aria-invalid": "true" })}
                    {...register("secSubTitle[en]", { required: true })}
                  />
                  {errors.secSubTitle && (
                    <div className="invalid-feedback">
                      <FormattedMessage id={"thisFieldIsRequired"} />
                    </div>
                  )}
                </div>
              </Col>

              <Col lg={6} xs={12}>
                <div className="form-group">
                  <h5>
                    <FormattedMessage id="title" /> ({" "}
                    <FormattedMessage id="arabic-language" /> )
                  </h5>
                  <input
                    type="text"
                    className={`form-control ${
                      errors.title ? "is-invalid" : ""
                    }`}
                    defaultValue={section?.secTitle?.ar || ""}
                    {...(errors.secTitle && { "aria-invalid": "true" })}
                    {...register("secTitle[ar]", { required: true })}
                  />
                  {errors.secTitle && (
                    <div className="invalid-feedback">
                      <FormattedMessage id={"thisFieldIsRequired"} />
                    </div>
                  )}
                </div>
              </Col>
              <Col lg={6} xs={12}>
                <div className="form-group">
                  <h5>
                    <FormattedMessage id="title" /> ({" "}
                    <FormattedMessage id="english-language" /> )
                  </h5>
                  <input
                    type="text"
                    className={`form-control ${
                      errors.title ? "is-invalid" : ""
                    }`}
                    defaultValue={section?.secTitle?.en || ""}
                    {...(errors.secTitle && { "aria-invalid": "true" })}
                    {...register("secTitle[en]", { required: true })}
                  />
                  {errors.secTitle && (
                    <div className="invalid-feedback">
                      <FormattedMessage id={"thisFieldIsRequired"} />
                    </div>
                  )}
                </div>
              </Col>

              <Col lg={6} xs={12}>
                <div className="form-group">
                  <h5>
                    <FormattedMessage id="description" /> ({" "}
                    <FormattedMessage id="arabic-language" /> )
                  </h5>
                  <textarea
                    className={`form-control ${
                      errors.title ? "is-invalid" : ""
                    }`}
                    defaultValue={section?.secDescription?.ar || ""}
                    {...(errors.secDescription && { "aria-invalid": "true" })}
                    {...register("secDescription[ar]", { required: true })}
                  ></textarea>
                  {errors.secDescription && (
                    <div className="invalid-feedback">
                      <FormattedMessage id={"thisFieldIsRequired"} />
                    </div>
                  )}
                </div>
              </Col>
              <Col lg={6} xs={12}>
                <div className="form-group">
                  <h5>
                    <FormattedMessage id="description" /> ({" "}
                    <FormattedMessage id="english-language" /> )
                  </h5>
                  <textarea
                    className={`form-control ${
                      errors.title ? "is-invalid" : ""
                    }`}
                    defaultValue={section?.secDescription?.en || ""}
                    {...(errors.secDescription && { "aria-invalid": "true" })}
                    {...register("secDescription[en]", { required: true })}
                  ></textarea>
                  {errors.secDescription && (
                    <div className="invalid-feedback">
                      <FormattedMessage id={"thisFieldIsRequired"} />
                    </div>
                  )}
                </div>
              </Col>

              <Col lg={12} xs={12}>
                <div className="form-group features">
                  <h5 className="d-flex justify-content-between align-items-center">
                    <FormattedMessage id="features" />
                    <button
                      type="button"
                      className="btn btn-green"
                      onClick={() =>
                        setFeatures([...features, { ar: "", en: "" }])
                      }
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "auto",
                      }}
                    >
                      <FormattedMessage id="addFeature" />
                    </button>
                  </h5>
                  {features.map((feature, index) => (
                    <div key={index} className="add-multi-component">
                      <button
                        type="button"
                        onClick={() => {
                          const newFeatures = features.filter(
                            (_, i) => i !== index
                          );
                          setFeatures(newFeatures);
                        }}
                        className="removeImg"
                        aria-label="remove"
                      >
                        <img src={removeImg} alt="" />
                      </button>
                      <Row>
                        <Col lg={6} xs={12}>
                          <div className="form-group">
                            <h5>
                              <FormattedMessage id="feature" /> ({" "}
                              <FormattedMessage id="arabic-language" /> )
                            </h5>
                            <input
                              type="text"
                              className="form-control form-outline"
                              value={feature.ar}
                              onChange={(e) => {
                                const newFeatures = [...features];
                                newFeatures[index].ar = e.target.value;
                                setFeatures(newFeatures);
                              }}
                              style={{
                                backgroundColor: "#fff",
                              }}
                            />
                          </div>
                        </Col>
                        <Col lg={6} xs={12}>
                          <div className="form-group">
                            <h5>
                              <FormattedMessage id="feature" /> ({" "}
                              <FormattedMessage id="english-language" /> )
                            </h5>
                            <input
                              type="text"
                              className="form-control form-outline"
                              value={feature.en}
                              onChange={(e) => {
                                const newFeatures = [...features];
                                newFeatures[index].en = e.target.value;
                                setFeatures(newFeatures);
                              }}
                              style={{
                                backgroundColor: "#fff",
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </div>
              </Col>

              <Col lg={12} xs={12}>
                <SaveChangesButton />
              </Col>
            </Row>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Index;
